import type { ProductLifecycleStatus } from '@bloom/shared';

/** Admin-facing names and what each status does, shared by the status picker and badges. */
export const LIFECYCLE_OPTIONS: Array<{ value: ProductLifecycleStatus; label: string; help: string }> = [
  { value: 'active', label: 'Active', help: 'In production and orderable.' },
  { value: 'discontinued', label: 'Not making more', help: 'Orderable until stock runs out; no replenishment. Marking it out of stock archives it.' },
  { value: 'archived', label: 'Archived', help: 'Hidden from every catalog and store and cannot be ordered. Kept for order history.' },
];

const STYLES: Record<Exclude<ProductLifecycleStatus, 'active'>, { label: string; className: string }> = {
  discontinued: { label: 'Not making more', className: 'bg-orange-100 text-orange-800' },
  archived: { label: 'Archived', className: 'bg-gray-200 text-gray-700' },
};

/** A badge for a product that is not plainly active; renders nothing for active products. */
export function LifecycleBadge({ status, audience = 'admin' }: { status?: ProductLifecycleStatus; audience?: 'admin' | 'clinic' }) {
  if (!status || status === 'active') return null;
  const style = STYLES[status];
  // Clinics only ever see discontinued products, and the useful part is that stock is finite.
  const label = audience === 'clinic' && status === 'discontinued' ? 'While supplies last' : style.label;
  return (
    <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${style.className}`}
      title={audience === 'clinic' ? 'This product is no longer being made; it can be ordered until current stock runs out.' : undefined}>
      {label}
    </span>
  );
}
